<template>
    <section class="user-action">
        <div class="container">
          <form v-on:submit.prevent autocomplete="off" class="form-login form-horizontal">
          <div class="login-container" v-if="!is_under_construction">
            <div class="row top-row">
              <div class="col-lg-3 col-md-3 col-sm-12 bg-gray1 text-center hidden-lg hidden-md">
                <img :src="app_site_logo" style="max-height: 55px; margin-bottom: 20px; margin-top: 20px;">
              </div>
              <div class="col-lg-3 col-md-3 col-sm-12 text-center bg-gray2 hidden-xs hidden-sm" style="height: 100%;">
                <img :src="app_site_logo" style="max-height: 55px;  margin-top: 10px;">
              </div>
              <div class="col-lg-9 col-md-9 col-sm-12 bg-gray2">
                  <div class="col-sm-12 col-md-4 col-lg-3 p-1">
                    <div class="form-group">
                        <label for="" class="col-lg-12 col-sm-12 control-label text-left login-label">ชื่อผู้ใช้</label>
                        <div class="col-lg-12 col-sm-12">
                          <input type="text" name="signup-form-username" class="form-control login-input" placeholder="กรอกชื่อผู้ใช้" aria-describedby="Username" v-model.trim="credentials.username" @input="$v.credentials.username.$touch()">
                        </div>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-4 col-lg-3 p-1">
                    <div class="form-group">
                      <label for="" class="col-lg-12 col-sm-12 control-label text-left login-label">รหัสผ่าน</label>
                      <div class="col-lg-12 col-sm-12">
                        <input type="password" name="signup-form-password" placeholder="กรอกรหัสผ่าน" class="form-control login-input" aria-describedby="Password" v-model.trim="credentials.password" @input="$v.credentials.password.$touch()">
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-4 col-lg-3 p-1">
                    <div class="visible-lg " style="margin-top:30px;"></div>
                    <router-link :to="{name: 'forgot'}" class="text-right text-gray1"><i class='fa fa-unlock'></i> ลืมรหัสผ่าน</router-link>
                  </div>
                  <div class="col-sm-12 col-md-4 col-lg-3">
                    <div class="visible-lg " style="margin-top:25px;"></div>
                    <div class="visible-md" style="margin-top:8px;"></div>
                    <button id="login-submit-button" class="btn btn-block mb-2" @click="submit()"><i class="fa fa-sign-in"></i> เข้าสู่ระบบ</button>
                  </div>
                  <div class="col-sm-12 visible-sm visible-xs">&nbsp;</div>
              </div>
            </div>
            
            <div class="row bg-bottom login-footer">
                <div class="col-xs-6 col-md-8 text-white">
                  <a :href="line_contact" target="_blank" class="text-white"><img :src="line_logo" style="height: 24px; "> ติดต่อแอดมิน</a>
                </div>
                <div class="col-xs-6 col-md-4 text-right text-white"><a :href="register_link" target="_self" class="text-white"><i class='fa fa-user-plus'></i> สมัครสมาชิก</a></div>
            </div>
          </div>

          <div class="col-xs-12" v-else>
            <div ref="step1" class="reg-box">
              <div class="regbox-body widget-body">

                <div class="bg-gray1 text-center">
                  <img :src="app_site_logo" style="max-height: 55px; margin-top: 20px; margin-bottom:20px;">
                </div>

                <div class="widget-main">
                  <h1 class="text-center">UNDER CONSTRUCTION</h1>
                  <p>
                  <h2 class="text-center">เว็บไซท์ของเราอยู่ในระหว่างการปิดปรับปรุงระบบชั่วคราว</h2>
                  <h2 class="text-center">เพื่อพัฒนาระบบและเพิ่มประสิทธิภาพการให้บริการที่ดียิ่งขึ้น</h2>
                </div>
                <div class="contact-footer">
                  <h5 class="text-primary">
                    <a :href="line_contact" target="_blank"><span class="badge badge-pill badge-primary font-weight-light"><i class="fa fa-phone"></i></span> ติดต่อเรา</a>
                  </h5>
                </div>
              </div>

            </div> <!-- end reg-box -->
          </div>

          </form>
 


        </div>
    </section>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import moment from 'moment'
moment.locale('th')

export default {
    name: 'login',
    data () {
        return {
            credentials: {
                username: '',
                password: ''
            },
            pending: false,
            current_date: moment( new Date() ).format('LL'),
            goves_result: {},
            yeekees_result: [],
            indexes_result: [],
            app_site_logo: '',
            line_logo: '',
            line_contact: '',
            is_under_construction: false,
            register_link: '',
        }
    },
    methods: {
        async submit () {
            if (this.$v.$invalid) { this.$v.$touch(); return }

            this.pending = true

            const credentials = {
                username: this.credentials.username,
                password: this.credentials.password
            }

            try {
                await this.$store.dispatch('user/userLogin', credentials)
                this.credentials.username = ''
                this.credentials.password = ''
                this.$v.$reset()
                this.$router.push({name: 'home'})
            } catch (error) {

                let wrongpass_code = /400/g
                let result_400 = wrongpass_code.test(error)

                let usernotfound_code = /401/g
                let result_401 = usernotfound_code.test(error)
                //console.log('result', result)

                if ( result_400 ) {
                    //400
                    this.$toasted.error('Invalid credentials')
                }
                else if ( result_401 ) {
                    //401
                    this.$toasted.error('User not found')
                }
                else {
                    this.$toasted.error('Hmm, those details don\'t seem right.')
                }

            } finally {
                this.pending = false
            }
        },

        async loadLottoResult (date_result) {

            if ( !date_result ) {
                date_result = moment(new Date()).format('YYYY-MM-DD')
            }

            try {

                const response = {}
                //const response = await this.$store.dispatch('lottoresult/getCurrentLottoResult', date_result)
                //console.log('async initial processForm', response)

                if ( response && response.goves ) {
                    this.goves_result = response.goves[0]

                    let th_date = this.formatThDate(response.goves[0].date_result)
                    this.goves_result.description = 'หวยรัฐบาล - ' + th_date

                    if ( response.goves[0].threefront && response.goves[0].threeback ) {
                        let [threefront_obj] = JSON.parse(response.goves[0].threefront)
                        let [threeback_obj] = JSON.parse(response.goves[0].threeback)

                        this.goves_result.threefront = threefront_obj.first + ' ' + threefront_obj.second
                        this.goves_result.threeback =  threeback_obj.first + ' ' + threeback_obj.second
                    }
                }

                if ( response && response.yeekees ) {
                    this.yeekees_result = response.yeekees
                }

                if ( response && response.indexes ) {
                    this.indexes_result = response.indexes
                }


            } catch (error) {
                console.log('error', error)
                this.$toasted.error('There was an error connecting to the server.')
            }
        },

        async loadRegisterLink () {

            try {
                const response = await this.$store.dispatch('information/getResgisterLink')
                if ( response ) {
                    this.register_link = response.header ? response.header : ( response.body ? response.body : process.env.VUE_APP_REGISTER_LINK )
                }
                else {
                    this.register_link = process.env.VUE_APP_REGISTER_LINK
                }

            } catch (error) {
                console.log('error', error)
            }
        },

        async loadLineContact () {
            try {
                const response = await this.$store.dispatch('information/getLineContact')
                this.line_contact = response.link
            } catch (error) {
                console.log('error', error)
            }
        },

        formatDate (value) {
            if (value) {
                let date = new Date(value)
                return moment(date).format('DD/MM/YYYY HH:mm:ss')
            }
        },

        formatThDate (value) {
            if (value) {
                let date = new Date(value)
                return moment( date ).format('LL')
            }
        },
    },

    created () {
        //this.loadLottoResult()

        let logo = (process.env.VUE_APP_SITE).toLowerCase() + '_logo.png'

        try {
            this.app_site_logo = require('@/assets/images/'+ logo)
        } catch (error) {
            this.app_site_logo = require('@/assets/images/'+ 'dummy_logo.png')
        }


        this.line_logo = require('@/assets/images/'+ 'LINE_APP.png')

        this.is_under_construction = process.env.VUE_APP_UNDER_CONSTRUCTION

        this.loadRegisterLink()
        this.loadLineContact()

    },

    validations: {
        credentials: {
            username: {
                required
            },
            password: {
                required
            }
        }
    }
}

//#;
</script>
<style lang="scss">

@media (min-width: 768px){
  .form-horizontal .control-label {
    text-align: left;
  }
}

.rule-box {
  color: #666;
  background: #fff;
  border-radius: 5px 5px 5px 5px;
  -moz-border-radius: 5px 5px 5px 5px;
  -webkit-border-radius: 5px 5px 5px 5px;
  margin: 5px auto;
}

.bg-bottom {
  background: linear-gradient(90deg, #0d2e2b 0%, #0a2320 100%);
}

.bg-gray1,
.bg-gray2 {
  background: linear-gradient(180deg, #1A4F4B 0%, #235E59 50%, #2A6E6B 100%);
}

.text-gray1 {
  color: #f6f1dc;
  font-weight: 500;

  &:hover {
    color: #d4a63a;
    text-decoration: none;
  }
}

#login-submit-button {

  background: linear-gradient(135deg, #8B6914 0%, #C9A23A 40%, #E8CC72 65%, #C4972A 100%);
  color: #fff7df;
  border: 1px solid #d9b35a;
  border-radius: 8px;
  font-weight: 700;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12);

  &:hover {
    background: linear-gradient(180deg, #b88724 0%, #976811 100%);
    color: #ffffff;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(212, 166, 58, 0.18);
  }
}

.login-footer {
  padding: 15px;
}

.login-container {
  border: 1px solid rgba(42, 110, 107, 0.75);
  border-radius: 12px;
  overflow: hidden;
  margin: 20px auto;
  box-shadow: 0 14px 34px rgba(26, 79, 75, 0.12);

  .top-row {
    padding: 10px;
    background: linear-gradient(135deg, #1A4F4B 0%, #235E59 50%, #2A6E6B 100%) !important;

    .flex-child-v-center {
      display: flex;
      align-items: center;
    }
  }
}

label {
  color: #f3f3f3;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.form-control {
  height: 38px;
  border-radius: 10px;
  border: 1px solid #cfe0df;
  background: #f8fafb;
  font-size: 14px;
  padding: 6px 10px;
  box-shadow: none;
  transition: all .2s ease;
}

.form-control:focus {
  border-color: #2A6E6B;
  background: #ffffff;
  box-shadow: 0 0 0 2px rgba(42, 110, 107, 0.18);
}

.form-control::placeholder {
  color: #a9afa5;
  font-size: 13px;
}

.form-group {
  margin-bottom: 14px;
}

.login-container img {
  border-radius: 12px;
}

.hidden-xs.hidden-sm.bg-gray2 img,
.hidden-lg.hidden-md.bg-gray1 img {
  max-height: 72px;
  padding: 1.5px;
  background: linear-gradient(180deg, #c7982e 0%, #8f6515 100%);
  border: 1px solid #d6b15a;
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12);
  filter: drop-shadow(0 3px 6px rgba(0,0,0,.12));
}

/* label */
.login-label {
  color: #f5f1e6;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.2px;
  margin-bottom: 7px;
  text-shadow: 0 1px 0 rgba(0, 0, 0, 0.08);
}

/* input */
.login-input {
  height: 40px;
  border-radius: 10px;
  border: 1px solid #cfe0df;
  background: #f8fafb;
  color: #1a2e2d;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 12px;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.03);
  transition: all 0.2s ease;
}

.login-input::placeholder {
  color: #a8afa5;
  font-size: 13px;
  font-weight: 400;
}

.login-input:focus {
  border-color: #2A6E6B;
  background: #ffffff;
  box-shadow: 0 0 0 2px rgba(42, 110, 107, 0.18);
}

.form-group {
  margin-bottom: 12px;
}
</style>